import { useParams } from 'react-router-dom';
import { Form, Row } from 'antd';

import { snapStore } from 'containers/Snaps/Snap/store';
import { FormModal, MilesText } from 'components';

import { usePutRequest } from 'hooks';

import { SnapCreateOpsComment, SnapDetails } from 'codegen';

import { fields, handleEscalateSuccess } from './escalateModalHelpers';

const { useForm } = Form;

export const EscalateModal = ({ open, onCancel }: { open: boolean; onCancel: () => void }) => {
  const activeTabKey = snapStore((state) => state.activeTabKey);

  const { snapId } = useParams();
  const [form] = useForm<SnapCreateOpsComment>();

  const [handleEscalate, { loading }] = usePutRequest<SnapDetails, SnapCreateOpsComment>({
    url: `/snaps/${snapId}/corrections/escalate`,
    options: {
      onSuccess: handleEscalateSuccess(onCancel, activeTabKey),
    },
  });

  return (
    <FormModal
      form={form}
      name='escalate'
      open={open}
      fields={fields}
      onCancel={onCancel}
      title='Escalate this snap to manager'
      onFinish={({ comment }) => handleEscalate({ payload: { comment } })}
      initialValues={{ comment: '' }}
      labelCol={{ span: 0 }}
      wrapperCol={{ span: 24 }}
      underTitleNode={(
        <Row className='mb-5'>
          <MilesText size='sm'>
            To send this snap on manager review please add comment about the complication you’ve met and press
            “Escalate this snap” button
          </MilesText>
        </Row>
      )}
      buttonProps={{
        label: 'Escalate this snap',
        danger: true,
        loading,
      }}
    />
  );
};
